import { IAllCaseInfo } from '../Interfaces';
import { CaseInformationModel } from './CaseInformation';
import { CaseInfoUpdateModel } from './CaseInfoUpdate';

export const InitialState : IAllCaseInfo = {
    interestOccurrences: { list: [], caseID: 0}, 
    caseInfo:CaseInformationModel,
    updatedCaseInfo:CaseInfoUpdateModel
}